export const customStyles = {
  option: (base, data) => ({
    ...base,
    color: data.value === "all" ? "black" : "#666666",
    backgroundColor: "#FFFFFF",
    ":active": {
      color: "#333536",
      backgroundColor: "#F6F7FD",
    },
    ":hover": {
      color: "#3399FF",
      backgroundColor: "#F6F7FD",
    },
    padding: "0.5rem 1rem",
    textOverflow: "ellipsis",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
  }),
  control: (provided) => ({
    ...provided,
    borderColor: "#eff0f6",
    opacity: 1,
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    background: "#eff0f6",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#3399ff",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#3399ff",
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "20px",
    background: "#eff0f6",
    opacity: 1,
  }),
};
